import { BaseViewStore, BaasicDropdownStore } from 'core/stores';
import { applicationContext, QueryUtility } from 'core/utils';
import { LookupService } from "common/services";
import { action, observable, runInAction } from 'mobx';
import { ModalParams } from 'core/models';
import _ from 'lodash';
import { FacilityOrderPatientNewFlowClinicalEditViewStore } from "application/facility-order-new-flow-clinical/stores";
import { FacilityOrderService, FacilityOrderTemplateService, FacilityOrderStatusService, ItemSubcategoryService, FacilityOrderTemplateItemService  } from "application/facility-order/services";
import { ItemCategoryService } from 'application/product/services';
import { FacilityOrderPatientService } from "application/facility-order-new-flow-insurance/services";
import { ClinicalStatusService } from 'application/clinical-status/services';
import { EligibilityStatusService } from "application/eligibility-status/services";
import { DocumentationRequestService } from "application/documentation-request/services";
import { MissingDocumentService } from 'application/missing-document/services';
import { FacilityInventoryCountDetailService } from "application/facility-inventory/services";
import { PickTicketHeaderService } from "application/pick-ticket/services";
import { LocalPatientService, PatientService } from "application/patient/services";
import { DiagnosisCodeService, LocalDoctorService } from "application/import/services";
import { ScheduleService } from 'application/schedule/services';
import moment from 'moment';

@applicationContext
class FacilityOrderNewFlowClinicalPreviewViewStore extends BaseViewStore {
    @observable accessor facilityOrder = null;
    @observable accessor facilityOrderPatientStores;
    @observable accessor selectedStatusAbrv;
    @observable accessor itemCategories = [];
    @observable accessor fetchingTemplates = false;
    @observable accessor disabled = false;
    @observable accessor disabledSendOrder = false;
    @observable accessor isStatusBarVisible = true;
    @observable accessor isEmpty = false;
    @observable accessor isReviewed = false;
    tabItems = [{ abrv: 'in-progress', name: 'In Progress' }, { abrv: 'discharge', name: 'Discharges' }, { abrv: 'reviewed-clinical', name: 'Reviewed-Clinical' }];
    @observable accessor questions = [{ id: "0", name: "Insurance questions" }, { id: "1", name: "Product questions" }];
    @observable accessor selectedQuestions = [];
    @observable accessor pickTicketHeaderStatus;
    @observable accessor notification;
    @observable accessor isDropdownOpen = false;
    @observable accessor isDocumentationRequestSent = false;
    @observable accessor hasMissingDocuments = false;

    constructor(rootStore) {
        super(rootStore);

        this.id = rootStore.routerStore.routerState.params.id;
        this.isAdmin = this.rootStore.userStore.user.roles.includes("Administrators");

        this.facilityOrderService = new FacilityOrderService(rootStore.application.baasic.apiClient);
        this.facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        this.facilityOrderStatusService = new FacilityOrderStatusService(rootStore.application.baasic.apiClient);
        this.itemSubcategoryService = new ItemSubcategoryService(rootStore.application.baasic.apiClient);
        this.facilityOrderTemplateItemService = new FacilityOrderTemplateItemService(rootStore.application.baasic.apiClient);
        this.itemCategoryService = new ItemCategoryService(rootStore.application.baasic.apiClient);
        this.facilityOrderPatientService = new FacilityOrderPatientService(rootStore.application.baasic.apiClient);
        this.lookupService = new LookupService(rootStore.application.baasic.apiClient);
        this.clinicalStatusService = new ClinicalStatusService(rootStore.application.baasic.apiClient);
        this.eligibilityStatusService = new EligibilityStatusService(rootStore.application.baasic.apiClient);
        this.facilityInventoryCountDetailService = new FacilityInventoryCountDetailService(rootStore.application.baasic.apiClient);
        this.localPatientService = new LocalPatientService(rootStore.application.baasic.apiClient);
        this.patientService = new PatientService(rootStore.application.baasic.apiClient);
        this.diagnosisCodeService = new DiagnosisCodeService(rootStore.application.baasic.apiClient);
        this.localDoctorService = new LocalDoctorService(rootStore.application.baasic.apiClient);
        this.scheduleService = new ScheduleService(rootStore.application.baasic.apiClient);

        this.itemCategoryStore = new BaasicDropdownStore({
            multi: true, filterable: false, initFetch: false
        }, {
            fetchFunc: async (term) => {
                const response = await this.itemCategoryService.find({
                    searchQuery: term,
                    rpp: 100
                });
                let filteredCategories = response.data.item.filter(i => this.facilityOrder.isEnteralWeek ? i.abrv === "enteral" : (i.abrv === "enteral" || i.abrv === "respiratory" || i.abrv === "urological"
                    || i.abrv === "ostomy"));
                return filteredCategories;
            },
        });

        this.queryUtility = new QueryUtility(this.rootStore, async filter => {
            await this.fetchFacilityOrderTemplates(filter);
        }, {});

        this.facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal = new ModalParams({});
        this.facilityOrderPatientNewFlowInsuranceEditModal = new ModalParams({});
        this.facilityOrderPatientNewFlowUSIntakeInsuranceInfoModal = new ModalParams({});
        this.facilityOrderPatientNewFlowInsuranceNoteModal = new ModalParams({});
        this.createFacilityOrderTemplateUSIntakeNewFlowModal = new ModalParams({});
        this.facilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowUSIntakeTemplateActivationModal = new ModalParams({});
        this.facilityOrderNewFlowUSIntakeFindAndReplaceModal = new ModalParams({});
        this.facilityOrderTemplateItemNewFlowCalculationModal = new ModalParams({});
        this.facilityOrderTemplateMissingDocumentNoteModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowUSIntakePortalNoteModal = new ModalParams({});
        this.facilityOrderTemplateDoNotSupplyModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal = new ModalParams({});
        this.facilityOrderTemplateItemNewFlowDeleteQuestionModal = new ModalParams({});
        this.facilityOrderTemplatePNMissingInformationModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowDeleteModal = new ModalParams({});
        this.facilityOrderTemplateItemNewFlowActivatePatientModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowInvoiceNoteModal = new ModalParams({});

        this.statusConfirmModal = new ModalParams({ onClose: null });
        this.statusConfirmModal.onConfirm = async () => { await this.setClinicalReviewStarted(); this.statusConfirmModal.close(); };
        this.statusConfirmModal.onCancel = () => { this.statusConfirmModal.close() };
        this.statusConfirmModal.yesLabel = 'MODAL.START_ANYWAYS_LABEL';
        this.statusConfirmModal.noLabel = 'MODAL.CANCEL_LABEL';
        this.statusConfirmModal.swapButtons = true;

        this.documentationRequestConfirmModal = new ModalParams({ onClose: null });
        this.documentationRequestConfirmModal.onConfirm = () => { this.openDocumentationRequestWindow(); this.documentationRequestConfirmModal.close(); };
        this.documentationRequestConfirmModal.onCancel = () => { this.openFacilityMissingDocumentsWindow(); this.documentationRequestConfirmModal.close(); };
        this.documentationRequestConfirmModal.yesLabel = 'Proceed with Email';
        this.documentationRequestConfirmModal.noLabel = 'View Facility Missing Docs';
        this.documentationRequestConfirmModal.swapButtons = true;

        this.extraSuppliesApprovalRequiredModal = new ModalParams({ onClose: null });
        this.extraSuppliesApprovalRequiredModal.yesLabel = 'MODAL.YES';
        this.extraSuppliesApprovalRequiredModal.onCancel = () => { this.extraSuppliesApprovalRequiredModal.close() };
        this.extraSuppliesApprovalRequiredModal.noLabel = 'MODAL.CANCEL_LABEL';
        this.extraSuppliesApprovalRequiredModal.swapButtons = true;

        this.importConfirmModal = new ModalParams({ onClose: null });
        this.importConfirmModal.onConfirm = async () => { this.importConfirmModal.close(); await this.importFacilityOrderNewFlow(); };
        this.importConfirmModal.onCancel = () => { this.importConfirmModal.close() };
        this.importConfirmModal.yesLabel = 'Yes';
        this.importConfirmModal.noLabel = 'No';

        this.importFacilityOrderConfirmModal = new ModalParams({ onClose: null });
        this.importFacilityOrderConfirmModal.onCancel = () => { this.importFacilityOrderConfirmModal.close() };
        this.importFacilityOrderConfirmModal.yesLabel = 'Yes';
        this.importFacilityOrderConfirmModal.noLabel = 'No';

        this.questionsStore = new BaasicDropdownStore(
            {
                multi: true,
                filterable: false,
            },
            {
                fetchFunc: () => {
                    return this.questions;
                },
            }
        );

        this.fetch([
            this.initialize()
        ]);

        let userRoles = this.rootStore.userStore.applicationUser.roles;
        this.isImportAllowed = userRoles.includes("Administrators");
    }

    @action.bound
    async initialize() {
        await this.initializeFacilityOrder();
        await this.initializeLookups();
        await this.setStatus(this.selectedStatusAbrv);

        const typeResponse = await this.scheduleService.getTypes();
            this.orderType = _.find(typeResponse.item, {abrv: 'ordering'});
    }

    @action.bound
    async initializeFacilityOrder() {
        const response = await this.facilityOrderService.get(this.id, { embed: 'Facility,Facility.FacilityAreaOfCares,Facility.Corporate_,FacilityOrderPatients,FacilityOrderStatuses' });
        const facilityOrder = response.data;
        const isInventoryStepAllowed = (await this.facilityOrderService.isInventoryStepAllowed(this.id)).data;
        const masterPatient = (await this.localPatientService.getByPatientKey(facilityOrder.facility.masterPatientId, { fields: 'id' })).data;
        runInAction(() => {
            this.facilityOrder = facilityOrder;
            this.isInventoryStepAllowed = isInventoryStepAllowed;
            this.pickTicketHeaderId = facilityOrder.pickTicketHeaderId;
            this.masterPatientId = masterPatient ? masterPatient.id : undefined;
        });
        await this.initializePickTicketHeader();
        await this.itemCategoryStore.filterAsync();
        this.rootStore.titleStore.setTitle(`Clinical Review - ${facilityOrder.facility.name}`);
        const documentationRequestService = new DocumentationRequestService(this.rootStore.application.baasic.apiClient);
        const hasMissingDocumentsResult = await documentationRequestService.checkMissingDocuments({ facilityOrderId: facilityOrder.id });
        runInAction(() => {
            this.facilityOrderStatus = facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'clinical-review');
            this.usIntakeStatus = facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "us-intake");
            this.disabled = !(this.facilityOrderStatus && this.facilityOrderStatus.startedOn) || this.isDisabled();
            this.disabledSendOrder = !this.isAdmin && facilityOrder && facilityOrder.sendOrder;
            this.isDocumentationRequestSent = facilityOrder.isDocumentationRequestSent;
            this.hasMissingDocuments = hasMissingDocumentsResult.data;
        });
    }

    @action.bound
    async initializePickTicketHeader() {
        if(!this.pickTicketHeaderId){
            this.pickTicketHeaderId = (await this.facilityOrderService.get(this.id, {fields: 'PickTicketHeaderId'})).data.pickTicketHeaderId;
        }
        if (this.pickTicketHeaderId) {
            const pickTicketHeaderService = new PickTicketHeaderService(this.rootStore.application.baasic.apiClient);
            const pickTicketHeader = (await pickTicketHeaderService.get(this.pickTicketHeaderId, { embed: "pickTicketHeaderStatus" })).data;
            this.pickTicketHeaderStatus = pickTicketHeader && pickTicketHeader.pickTicketHeaderStatus && pickTicketHeader.pickTicketHeaderStatus.abrv;
        }
    }

    @action.bound
    isDisabled() {
        return !this.usIntakeStatus && !this.facilityOrderStatus;
    }

    @action.bound
    async initializeLookups() {
        const lookups = await this.lookupService.getLookups("NewFlowStatus,ItemCategory,SubCategory,ImportAction,ImportDetailStatus,ImportHeaderStatus,SpecialtyType,DiagnosisCode");
        const enteralItemCategoryId = _.find(lookups.itemCategory, s => { return s.abrv === 'enteral'; }).id;
        this.enteralItemCategoryId = enteralItemCategoryId;
        let queryParams = this.rootStore.routerStore.routerState.queryParams;

        let openReviewedClinicalTab = false;
        if(this.facilityOrderStatus && this.facilityOrderStatus.completedOn){
            openReviewedClinicalTab = !(await this.hasAnyTemplateInProgress());
        }

        const selectedStatusAbrv = _.find(lookups.newFlowStatus, s => {
            return queryParams && queryParams.newFlowClinicalStatusId ? s.id === queryParams.newFlowClinicalStatusId : openReviewedClinicalTab ? s.abrv === 'reviewed-clinical' : s.abrv === 'in-progress';
        }).abrv;

        const clinicalStatuses = (await this.clinicalStatusService.find({ rpp: 50 })).data.item;

        const missingDocumentService = new MissingDocumentService(this.rootStore.application.baasic.apiClient);
        const missingDocuments = (await missingDocumentService.find({ rpp: 100, isActive: true, sort: 'name|asc' })).data.item;

        runInAction(() => {
            this.lookups = lookups;
            this.selectedStatusAbrv = selectedStatusAbrv;
            this.clinicalStatuses = clinicalStatuses;
            this.missingDocuments = missingDocuments;
        });
    }
    
    @action.bound
    async hasAnyTemplateInProgress() {
        let params = {
            pageSize: 1,
            facilityOrderId: this.id,
            fields: 'id',
            isReviewed: true,
            isDischarged: false,
            isClinicalReviewed: false,
            itemCategoryIds: this.facilityOrder.isEnteralWeek ? [this.enteralItemCategoryId] : undefined,
            masterPatientId: this.facilityOrder.isEnteralWeek ? this.masterPatientId : undefined
        }
        const response = await this.facilityOrderTemplateService.find(params);
        return response.data.item && response.data.item.some(x => x.id);
    }

    @action.bound
    async setStatus(statusAbrv) {
        this.isEmpty = false;
        this.selectedStatusAbrv = statusAbrv;
        const statusId = _.find(this.lookups.newFlowStatus, s => {
            return s.abrv === statusAbrv;
        }).id;
        this.queryUtility.filter.set('newFlowClinicalStatusId', statusId);
        this.queryUtility.fetch();
        this.isDropdownOpen = false;
    }

    @action.bound
    async fetchFacilityOrderTemplatesByPatient(patientId, ids) {
        var itemCategoryIds = _.map(this.itemCategories, (i => { return i.id }));
        let params = {
            ...this.queryUtility.plainFilter,
            pageSize: 10000,
            facilityOrderId: this.id,
            patientId: patientId,
            embed: 'PastFacilityOrderTemplate,FacilityOrderTemplateInitial,FacilityOrderTemplateInitial.OrderingDoctor,FacilityOrderTemplateInitial.ClinicalStatus,FacilityOrderTemplateItems,Patient,SubCategory,ItemCategory,ImportReference,NewFlowStatus,NewFlowInsuranceStatus,NewFlowUSIntakeStatus,ReviewUSIntakeValidations,FacilityOrderTemplateMissingDocuments,FacilityOrderTemplateMissingDocumentInitials,OrderingDoctor,ClinicalStatus,IsFacilityOrderTemplateItemInitial,ImportDetailStatus',
            orderBy: "SubCategory",
            orderDirection: "asc",
            isReviewed: true,
            isDischarged: false,
            itemCategoryIds: this.facilityOrder.isEnteralWeek ? [this.enteralItemCategoryId] : (itemCategoryIds && itemCategoryIds.length > 0) ? itemCategoryIds : undefined,
            masterPatientId: this.facilityOrder.isEnteralWeek ? this.masterPatientId : undefined
        }

        if (this.selectedStatusAbrv !== "discharge") {
            params = _.extend(params, {
                isClinicalReviewed: this.selectedStatusAbrv === "reviewed-clinical" ? true : false,
            });
        }
        else {
            params.isDischarged = true;
        }

        if (ids) {
            params.ids = ids;
            params.isReviewed = undefined;
            params.isDischarged = undefined;
            params.isClinicalReviewed = undefined;
        }

        this.checkIsReviewed();
        const facilityOrderTemplates = (await this.facilityOrderTemplateService.find(params)).data.item;
        const facilityOrderPatient = this.facilityOrder.facilityOrderPatients && this.facilityOrder.facilityOrderPatients.find(p => p.patientId === patientId);
        if (facilityOrderPatient && facilityOrderTemplates.some(x => x.id)) {
            return facilityOrderTemplates;
        }
    }

    @action.bound
    async fetchFacilityOrderTemplates(filter) {
        runInAction(() => {
            this.fetchingTemplates = true;
        });
        var itemCategoryIds = _.map(this.itemCategories, (i => { return i.id }));
        let params = {
            ...filter,
            pageSize: 10000,
            facilityOrderId: this.id,
            embed: 'PastFacilityOrderTemplate,FacilityOrderTemplateInitial,FacilityOrderTemplateInitial.OrderingDoctor,FacilityOrderTemplateInitial.ClinicalStatus,FacilityOrderTemplateItems,Patient,SubCategory,ItemCategory,ImportReference,NewFlowStatus,NewFlowInsuranceStatus,NewFlowUSIntakeStatus,ReviewUSIntakeValidations,FacilityOrderTemplateMissingDocuments,FacilityOrderTemplateMissingDocumentInitials,OrderingDoctor,ClinicalStatus,IsFacilityOrderTemplateItemInitial,ImportDetailStatus',
            orderBy: "SubCategory",
            orderDirection: "asc",
            isReviewed: true,
            isDischarged: false,
            itemCategoryIds: this.facilityOrder.isEnteralWeek ? [this.enteralItemCategoryId] : (itemCategoryIds && itemCategoryIds.length > 0) ? itemCategoryIds : undefined,
            masterPatientId: this.facilityOrder.isEnteralWeek ? this.masterPatientId : undefined
        }

        if (this.selectedStatusAbrv !== "discharge") {
            params = _.extend(params, {
                isClinicalReviewed: this.selectedStatusAbrv === "reviewed-clinical" ? true : false,
            });
        }
        else {
            params.isDischarged = true;
        }

        let showInsuranceQuestionPatients = this.selectedQuestions.some(x => x.id === "0");
        let showMissingProductTemplates = this.selectedQuestions.some(x => x.id === "1");

        const facilityOrderTemplates = (await this.facilityOrderTemplateService.find(params)).data.item;
        let grouped = _.groupBy(facilityOrderTemplates, 'patientId');

        let facilityOrderTemplatesGroupByPatient = [];
        _.each(grouped, (val, key) => {
            let facilityOrderPatient = this.facilityOrder.facilityOrderPatients && this.facilityOrder.facilityOrderPatients.find(p => p.patientId === key);
            let filteredItems = showMissingProductTemplates ? val.filter(x => x.missingProduct) : val;
            if ((showInsuranceQuestionPatients && facilityOrderPatient.insuranceQuestion && facilityOrderPatient.insuranceQuestion !== "") ||
                (showMissingProductTemplates && filteredItems.length > 0)) {
                if (facilityOrderPatient) {
                    facilityOrderTemplatesGroupByPatient.push({ id: key, item: filteredItems, facilityOrderPatient: facilityOrderPatient, pageViewStore: this});
                }
            }
            else if (!showInsuranceQuestionPatients && !showMissingProductTemplates) {
                if (facilityOrderPatient) {
                    facilityOrderTemplatesGroupByPatient.push({ id: key, item: val, facilityOrderPatient: facilityOrderPatient, pageViewStore: this});
                }
            }
        });

        const facilityOrderPatientStores = facilityOrderTemplatesGroupByPatient.map(item =>
            new FacilityOrderPatientNewFlowClinicalEditViewStore(this.rootStore, item)
        );
        runInAction(() => {
            this.facilityOrderPatientStores = facilityOrderPatientStores;
            this.isEmpty = this.selectedStatusAbrv == "in-progress" && (!this.itemCategories || this.itemCategories.length == 0) && this.facilityOrderStatus && !this.facilityOrderStatus.completedOn && !facilityOrderPatientStores.some(i => i);
            this.fetchingTemplates = false;
        });

        this.checkIsReviewed();
    }

    @action.bound
    async goToFacilityPreview() {
        window.open(`${this.rootStore.routerStore.findRoute('master.app.main.facility.preview').pattern.replace(":id", this.facilityOrder.facilityId)}`);
    }

    @action.bound
    async goToFacilityCalendar() {
        window.open(`${this.rootStore.routerStore.findRoute('master.app.main.schedule.calendar').pattern}?facilityId=${this.facilityOrder.facilityId}&calendarTypeId=${this.orderType.id}`);
    }

    @action.bound
    async downloadFacilityOrder() {
        const downloadUrl = `${(await this.facilityOrderTemplateService.getDownloadNewFlowUrl({ ...this.queryUtility.plainFilter, facilityOrderId: this.facilityOrder.id }))}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl
            }&ttype=${this.rootStore.authStore.token.type}`
        window.open(downloadUrl, "_blank")
    }

    @action.bound
    async downloadFacilityOrderCsv() {
        const downloadUrl = `${(await this.facilityOrderTemplateService.getDownloadNewFlowCsvUrl({ ...this.queryUtility.plainFilter, facilityOrderId: this.facilityOrder.id }))}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl
            }&ttype=${this.rootStore.authStore.token.type}`
        window.open(downloadUrl, "_blank")
    }

    @action.bound
    async filterByCategory(selected) {
        this.itemCategories = selected.value;
        this.queryUtility.fetch();
    }

    @action.bound
    async startClinicalReview() {
        await this.getFacilityOrderStatus();
        if (!(this.usIntakeStatus && this.usIntakeStatus.completedOn)) {
            this.statusConfirmModal.open({
                message: "US Intake has not yet completed their flow. You can start Clinical Review, but will not be able to complete it until US Intake completes their flow. Please note that you will not see any templates that US Intake hasn’t reviewed yet."
            });
        }
        else {
            await this.setClinicalReviewStarted();
        }
    }

    @action.bound
    async getFacilityOrderStatus() {
        var statusesResponse = await this.facilityOrderStatusService.find({ facilityOrderId: this.facilityOrder.id, embed: "Status,StartedByUser,CompletedByUser" });
        if (statusesResponse.data) {
            this.facilityOrder.facilityOrderStatuses = statusesResponse.data.item;
            this.usIntakeStatus = this.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "us-intake");
        }

        this.changeStatusBarVisibility();
        this.changeStatusBarVisibility();
    }

    @action.bound
    async setClinicalReviewStarted() {
        if (this.facilityOrderStatus)
            return;

        try {
            const status = this.lookups.importHeaderStatus.find(i => i.abrv === 'clinical-review');
            var response = await this.facilityOrderStatusService.create({ facilityOrderId: this.facilityOrder.id, statusId: status.id, startedOn: new Date(), startedByUserId: this.rootStore.userStore.user.id });
            var statusesResponse = await this.facilityOrderStatusService.find({ facilityOrderId: this.facilityOrder.id, embed: "Status,StartedByUser,CompletedByUser" });

            if (response.data) {
                this.facilityOrderStatus = response.data;
                this.disabled = false;

                const temp = this.facilityOrderPatientStores;
                this.facilityOrderPatientStores = null;
                this.facilityOrderPatientStores = temp;
            }

            if (statusesResponse.data) {
                this.facilityOrder.facilityOrderStatuses = statusesResponse.data.item;
            }

            this.checkIsEmpty();

            this.changeStatusBarVisibility();
            this.changeStatusBarVisibility();
        }
        catch (err) {
            this.rootStore.notificationStore.error("The facility order status has already been updated. Please reload the page.");
        }
    }

    @action.bound
    async setClinicalReviewCompleted() {
        if (!this.facilityOrderStatus || this.facilityOrderStatus.completedOn)
            return;

        try {
            const request = { ...this.facilityOrderStatus, completedOn: new Date(), completedByUserId: this.rootStore.userStore.user.id };
            await this.facilityOrderStatusService.update(request);
            await this.refreshFacilityOrderStatus();
        }
        catch (err) {
            this.rootStore.notificationStore.error("The facility order status has already been updated. Please reload the page.");
        }
    }

    @action.bound
    async refreshFacilityOrderStatus() {
        var statusesResponse = await this.facilityOrderStatusService.find({ facilityOrderId: this.facilityOrder.id, embed: "Status,StartedByUser,CompletedByUser" });
        if (statusesResponse.data) {
            this.facilityOrder.facilityOrderStatuses = statusesResponse.data.item;
        }

        let facilityOrderStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'clinical-review');
            if (facilityOrderStatus) {
                this.facilityOrderStatus = facilityOrderStatus;

                const temp = this.facilityOrderPatientStores;
                this.facilityOrderPatientStores = null;
                this.facilityOrderPatientStores = temp;
            }

            this.checkIsEmpty();

            this.changeStatusBarVisibility();
            this.changeStatusBarVisibility();
    }

    @action.bound
    changeStatusBarVisibility() {
        this.isStatusBarVisible = !this.isStatusBarVisible;
    }

    @action.bound
    insuranceCoverageStatusOverviewEmailEdit() {
        window.open(`${this.rootStore.routerStore
            .findRoute('master.app.main.facility-order.facility-order-new-flow.overview')
            .pattern.replace(":facilityOrderId", this.id)}?isNiko=false
            `);
    }

    @action.bound
    async documentationRequestCreate() {
        const documentationRequestService = new DocumentationRequestService(this.rootStore.application.baasic.apiClient);
        var result = await documentationRequestService.checkMissingDocuments({ facilityOrderId: this.facilityOrder.id });
        if (result.data) {
            let params = {
                pageSize: 1,
                facilityId: this.facilityOrder.facilityId,
                facilityOrderIdToExclude: this.facilityOrder.id,
                includeInDocReqEmail: true,
                fields: "id",
                dosDateFrom: moment(new Date()).add(-1,'y').format('YYYY-MM-DD'),
                itemCategoryIds: this.facilityOrder.isEnteralWeek ? [this.enteralItemCategoryId] : undefined,
                masterPatientId: this.facilityOrder.isEnteralWeek ? this.masterPatientId : undefined
            }

            const response = await this.facilityOrderTemplateService.find(params);
            if (response.data.item && response.data.item.some(i => i)) {
                this.documentationRequestConfirmModal.open({
                    message: "Past templates will be included on this Doc Request Email. Would you like to view them or proceed with generating the email?"
                });
            }
            else {
                this.openDocumentationRequestWindow();
            }
        }
        else {
            this.rootStore.notificationStore.error("There are no missing documents for this Facility order.");
        }
    }

    @action.bound
    openDocumentationRequestWindow() {
        window.open(`${this.rootStore.routerStore
            .findRoute('master.app.main.facility-order.documentation-request-new-flow.edit-email')
            .pattern.replace(":facilityOrderId", this.id)}
            `);
    }

    @action.bound
    openFacilityMissingDocumentsWindow() {
        window.open(`${this.rootStore.routerStore
            .findRoute('master.app.main.facility-missing-docs.preview')
            .pattern.replace(":id", this.facilityOrder.facilityId).replace(":showOnlyPastTemplates", true)}
            `);
    }

    @action.bound
    async signalRAction(message) {
        if(message.text && (message.userId != this.rootStore.userStore.user.id && this.facilityOrderPatientStores && this.facilityOrderPatientStores.some(fo => fo && ((fo.items && fo.items.some(i => i && i.id == message.id)) || fo.id == message.id)))){
            this.notification = message.text;
        } 
        else if (message.table == "PTH") {
            this.initializePickTicketHeader();
        }
        else if (message.column == "SendOrder") {
            this.facilityOrder.sendOrder = true;
            this.disabledSendOrder = !this.isAdmin;
        }
        else if (message.table === "FOTI"){
            await this.refreshFacilityOrderTemplates();
        }
        else if (message.table === "FOS"){
            await this.refreshFacilityOrderStatus();
        }
        else if (message.table == "ReloadClinicalTemplate" && message.userId == this.rootStore.userStore.user.id) {
            if(message.text == 'Template has been updated.'){
                this.rootStore.notificationStore.success("Facility order template(s) imported successfully.");
            }
            else{
                this.rootStore.notificationStore.error(message.text);
            }
        }
        else if(message.table == "SE") {
            if(message.column == "EmailType" && message.id == this.facilityOrder.id)
            {
                if(message.text == "DocumentationRequest")
                {
                    this.isDocumentationRequestSent = true;
                }              
            }
        }
    }

    @action.bound
    async checkIsEmpty(isReview) {
        await this.checkIsReviewed();
        this.isEmpty = this.selectedStatusAbrv == "in-progress" && (!this.itemCategories || this.itemCategories.length == 0) && this.facilityOrderStatus && !this.facilityOrderStatus.completedOn && !this.facilityOrderPatientStores.some(i => i.facilityOrderTemplateStores && i.facilityOrderTemplateStores.some(j => j));
        if(isReview && this.isEmpty && !this.isReviewed && this.usIntakeStatus && this.usIntakeStatus.completedOn){
            await this.setStatus('discharge');
        }
    }

    @action.bound
    async checkIsReviewed() {
        let params = {
            pageSize: 1,
            facilityOrderId: this.id,
            isClinicalReviewed: false,
            fields: "id",
            itemCategoryIds: this.facilityOrder.isEnteralWeek ? [this.enteralItemCategoryId] : undefined,
            masterPatientId: this.facilityOrder.isEnteralWeek ? this.masterPatientId : undefined
        }

        const response = await this.facilityOrderTemplateService.find(params);
        const isDocumentationRequestSent = (await this.facilityOrderService.hasSentEmail(this.facilityOrder.id, "DocumentationRequest")).data;
        const documentationRequestService = new DocumentationRequestService(this.rootStore.application.baasic.apiClient);
        const hasMissingDocuments = (await documentationRequestService.checkMissingDocuments({ facilityOrderId: this.facilityOrder.id })).data;
        runInAction(() => {
            this.isReviewed = response.data.item && !response.data.item.some(i => i);
            this.isDocumentationRequestSent = isDocumentationRequestSent;
            this.hasMissingDocuments = hasMissingDocuments;
        });
    }

    @action.bound
    async filterByQuestion(selected) {
        this.selectedQuestions = selected.value;
        this.queryUtility.fetch();
    }

    @action.bound
    downloadInventoryReport() {
        const downloadUrl = `${this.facilityInventoryCountDetailService.getDownloadInventoryReportUrl({ facilityOrderId: this.facilityOrder.id })}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`;
        window.open(downloadUrl, "_blank");
    }

    @action.bound
    async openFacilityOrderNewFlowUSIntakeFindAndReplaceModal() {
        let errorMessage = null;
        if(this.disabled){
            errorMessage ="This action is not allowed until the Clinical Review is started.";
        }
        else if(this.facilityOrder.pickTicketHeaderId){
            const pickTicketHeaderService = new PickTicketHeaderService(this.rootStore.application.baasic.apiClient);
            const pickTicketHeader = (await pickTicketHeaderService.get(this.facilityOrder.pickTicketHeaderId, { embed: "pickTicketHeaderStatus", fields: "pickTicketHeaderStatus" })).data;
            if(pickTicketHeader && pickTicketHeader.pickTicketHeaderStatus && pickTicketHeader.pickTicketHeaderStatus.abrv != "new"){
                errorMessage = pickTicketHeader.pickTicketHeaderStatus.abrv == "in-progress" ? "This action is not allowed because purchasing is in progress." : "This action is not allowed because purchasing is complete.";
            }
        }
        if(errorMessage){
            this.rootStore.notificationStore.error(errorMessage);
            return;
        }

        this.facilityOrderNewFlowUSIntakeFindAndReplaceModal.open({
            facilityOrderId: this.facilityOrder.id,
            fetchData: () => this.queryUtility.fetch()
        });
    }

    @action.bound
    async importFacilityOrder() {
		var result = (await this.facilityOrderTemplateService.importCheck(this.facilityOrder.id)).data;
        if(!result.success){
            return this.rootStore.notificationStore.error(result.errors);
        }

        await this.importConfirmModal.open({
            message: 'FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_IMPORT'
        });
    }

    async importFacilityOrderNewFlow(){
        try{
            this.rootStore.notificationStore.success("Importing template(s) to Brightree is in progress.");
            await this.facilityOrderService.importFacilityOrderNewFlow({ facilityOrderId: this.facilityOrder.id });
        }
        catch (err) {
            if (err.data && err.data.errors) {
                this.rootStore.notificationStore.error(err.data.errors);
            }
            else {
                this.rootStore.notificationStore.error("Error occurred while trying to import a facility order template(s).");
            }
        }
    }

	@action.bound
	orderHistory() {
        window.open(this.rootStore.routerStore.findRoute("master.app.main.facility-order.facility-order-new-flow.history").pattern.replace(":id", this.facilityOrder.id));
    }

    @action.bound
    async goToCreatePatient() {
        let errorMessage = null;
        if(this.disabled){
            errorMessage ="This action is not allowed until the Clinical Review is started.";
            this.rootStore.notificationStore.error(errorMessage);
        }
        else {
            this.rootStore.routerStore.goTo('master.app.main.facility-order.facility-order-new-flow.clinical-preview-create-patient', {
                id: this.facilityOrder.id
            });
        }
    }
    @action.bound
    async refreshFacilityOrderTemplates() {
        var itemCategoryIds = _.map(this.itemCategories, (i => { return i.id }));
        let params = {
            pageSize: 10000,
            facilityOrderId: this.id,
            embed: 'PastFacilityOrderTemplate,FacilityOrderTemplateInitial,FacilityOrderTemplateInitial.OrderingDoctor,FacilityOrderTemplateInitial.ClinicalStatus,FacilityOrderTemplateItems,Patient,SubCategory,ItemCategory,ImportReference,NewFlowStatus,NewFlowInsuranceStatus,NewFlowUSIntakeStatus,ReviewUSIntakeValidations,FacilityOrderTemplateMissingDocuments,FacilityOrderTemplateMissingDocumentInitials,OrderingDoctor,ClinicalStatus,IsFacilityOrderTemplateItemInitial,ImportDetailStatus',
            orderBy: "SubCategory",
            orderDirection: "asc",
            isReviewed: true,
            isDischarged: false,
            itemCategoryIds: this.facilityOrder.isEnteralWeek ? [this.enteralItemCategoryId] : (itemCategoryIds && itemCategoryIds.length > 0) ? itemCategoryIds : undefined,
            masterPatientId: this.facilityOrder.isEnteralWeek ? this.masterPatientId : undefined
        }

        if (this.selectedStatusAbrv !== "discharge") {
            params = _.extend(params, {
                isClinicalReviewed: this.selectedStatusAbrv === "reviewed-clinical" ? true : false,
            });
        }
        else {
            params.isDischarged = true;
        }

        let showInsuranceQuestionPatients = this.selectedQuestions.some(x => x.id === "0");
        let showMissingProductTemplates = this.selectedQuestions.some(x => x.id === "1");

        const facilityOrderTemplates = (await this.facilityOrderTemplateService.find(params)).data.item;
        let grouped = _.groupBy(facilityOrderTemplates, 'patientId');

        let facilityOrderTemplatesGroupByPatient = [];
        _.each(grouped, (val, key) => {
            let facilityOrderPatient = this.facilityOrder.facilityOrderPatients && this.facilityOrder.facilityOrderPatients.find(p => p.patientId === key);
            let filteredItems = showMissingProductTemplates ? val.filter(x => x.missingProduct) : val;
            if ((showInsuranceQuestionPatients && facilityOrderPatient.insuranceQuestion && facilityOrderPatient.insuranceQuestion !== "") ||
                (showMissingProductTemplates && filteredItems.length > 0)) {
                if (facilityOrderPatient) {
                    facilityOrderTemplatesGroupByPatient.push({ id: key, item: filteredItems, facilityOrderPatient: facilityOrderPatient, pageViewStore: this});
                }
            }
            else if (!showInsuranceQuestionPatients && !showMissingProductTemplates) {
                if (facilityOrderPatient) {
                    facilityOrderTemplatesGroupByPatient.push({ id: key, item: val, facilityOrderPatient: facilityOrderPatient, pageViewStore: this});
                }
            }
        });

        this.facilityOrderPatientStores.map(store => {
            facilityOrderTemplatesGroupByPatient.map(item => {
                if (item.id === store.id){
                    store.items.map(si => {
                        let temp = item.item.find(i => i.id === si.id);
                        if (temp){
                            si.isDifferentQty = temp.facilityOrderTemplateItems.some(templateItem => templateItem.orderQuantity !== templateItem.templateQuantity);
                            si.facilityOrderTemplateItems = temp.facilityOrderTemplateItems;
                            si.facilityOrderTemplateItems.map(j => {
                                j.isOrderQuantityChanged = j.facilityOrderTemplateItemInitial && (j.facilityOrderTemplateItemInitial.orderQuantity !== j.orderQuantity);
                            });
                        }
                    })
                }
            });
        });
    }

}

export default FacilityOrderNewFlowClinicalPreviewViewStore;
